import React, { useState } from 'react';

import { Box, Tab, Tabs, Typography } from '@mui/material';

import PrimaryLayout from '../components/layout/PrimaryLayout';
import SecretsList from '../views/secrets-and-variables/SecretsList';
import VariablesList from '../views/secrets-and-variables/VariablesList';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const SecretsAndVariables: React.FC = () => {
    const [value, setValue] = useState<number>(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <PrimaryLayout>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab label="Secrets" {...a11yProps(1)} />
                    <Tab label="Variables" {...a11yProps(2)} />
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <Box sx={{ mx: 2, my: 2 }}>
                    <Typography variant="body1" color="text.secondary">
                        <strong>Secrets</strong> are encrypted environment-specific values (e.g., API keys, credentials) securely accessed by workflows and blocks at runtime.
                        Manage sensitive runtime configurations here — similar to a secrets vault for your system.
                    </Typography>
                </Box>
                <SecretsList />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
                <Box sx={{ mx: 2, my: 2 }}>
                    <Typography variant="body1" color="text.secondary">
                        <strong>Variables</strong> are non-sensitive configuration values used across workflows and blocks (e.g., feature flags, constants).
                        Manage reusable runtime variables here to ensure consistency and flexibility in your execution environments.
                    </Typography>
                </Box>
                <VariablesList />
            </CustomTabPanel>
        </PrimaryLayout>
    )
}

export default SecretsAndVariables